
import
{
  RepeatOutlined,
  SyncAltOutlined,
  HdrWeakOutlined,
  RadarOutlined,
  SportsSoccerOutlined,
  FilterTiltShiftOutlined,
} from '@mui/icons-material';

import { getCachedAllProgrammeStats, getCachedSingleProgrammeStats } from './statsHelper';

const getRank = (profileId, leaderboard) =>
{
  if (!leaderboard)
  {
    return 0;
  }
  return leaderboard.find(
    (score) => score.profileId === Number(profileId))?.rank
};

export const getDeepProgrammeStats = async (profileId, programmes) =>
{
  // Get full stats for each programme (session)
  let hasErrors = false,
    data = [];

  let responses = [];
  for (const programme of programmes)
  {
    //const singleProgrammeStatsData = programme.stats;
    //    const singleProgrammeStatsData = await getCachedSingleProgrammeStats(profileId, programme.id);
    //  responses.push(singleProgrammeStatsData);
    data.push(programme.stats);
  }


  return {
    hasErrors,
    data,
  };
};

export const getSortedProgrammes = sessions =>
{
  // Sort programmes in date order - newest to oldest
  sessions.sort((a, b) =>
  {
    const dateA = new Date(a.created),
      dateB = new Date(b.created);
    return dateB - dateA;
  });
  return sessions;
};

// Create a map of stat names
const programDrillStatsMap = {
  'avg_score': {
    programStatName: 'avg_score',
  },
  'avg_right_foot_shots': {
    programStatName: 'avg_right_foot_shots',
  },
  'avg_left_foot_shots': {
    programStatName: 'avg_left_foot_shots',
  },
  'avg_average_dwell': {
    programStatName: 'avg_average_dwell',
  },
  'avg_correct': {
    programStatName: 'avg_correct',
  },
  'avg_goals': {
    programStatName: 'avg_goals',
  },
  'avg_incorrect': {
    programStatName: 'avg_incorrect',
  }
}

const getAverage = (drillStats, drillId, statName) =>
{
  // const drillStats.map((stat) => )
  const total = drillStats.map((stat) => stat[drillId]?.latestStat).reduce((previousValue, currentValue) =>
  {

    return previousValue + (currentValue && currentValue[statName] ? currentValue[statName] : 0)
  }
    , 0);
  return total / drillStats.length;
}

const getDrillStatFromProgramme = (drillStats, displayDrillId, drillId, drillStatNames) =>
{
  const individualDrillStats = drillStatNames.map(statName =>
  {
    // const statName = Array.isArray(statName) ? statName[0] : statName;
    // const average = programDrillStatsMap[statName]?.averageStatName ? drillStats[0][drillId]?.allTime[programDrillStatsMap[statName].averageStatName] : 0;
    const newAverage = getAverage(drillStats, drillId, statName);
    return {
      [statName]: {
        average: newAverage,
        scores: drillStats.map((stat, index) =>
        {
          const statNameToUse = programDrillStatsMap[statName]?.programStatName;
          if (!statNameToUse)
          {
            console.error(`${statName} missing`);
          }
          return {
            score: stat[drillId]?.latestStat[statNameToUse],
            createdAt: new Date(stat[drillId]?.latestFullDate)
          }
        }),
      }
    }
  });
  return {
    drillId: displayDrillId,
    stats: individualDrillStats
  };
}

export const generateDrilllStatsProgrammes = async (playerId, programmes) =>
{
  const { hasErrors, data } = await getDeepProgrammeStats(playerId, programmes);
  if (hasErrors) return { success: false };
  const drillStats = data.map((stat) => stat.drillStats);
  const drillStatsProgrammes = [
    getDrillStatFromProgramme(
      drillStats,
      'rondo-scan',
      'rondo_scan',
      [
        'avg_score',
        'avg_right_foot_shots',
        'avg_left_foot_shots',
        'avg_average_dwell',
      ]
    ),
    getDrillStatFromProgramme(
      drillStats,
      'colour-combo',
      'colour_combo',
      [
        'avg_score',
        'avg_correct',
        'avg_incorrect'
      ]
    ), getDrillStatFromProgramme(
      drillStats,
      'wolfy-180',
      'wolfy_180',
      [
        'avg_score',
        'avg_correct',
        'avg_incorrect',
      ]
    ),
    getDrillStatFromProgramme(
      drillStats,
      'shoulder-sums',
      'shoulder_sums',
      [
        'avg_score',
        'avg_goals',
        'avg_right_foot_shots',
        'avg_left_foot_shots'
      ]
    ),
    getDrillStatFromProgramme(
      drillStats,
      'pressure-pass',
      'pressure_pass',
      [
        'avg_score',
        'avg_correct',
        'avg_incorrect',
        'avg_right_foot_shots',
        'avg_left_foot_shots',
        'avg_average_dwell'
      ]
    ),

  ];
  return drillStatsProgrammes;
}


export const fetchDrillStatsProgrammes = async (playerId, allProgrammeSessions, programmeIndex) =>
{
  const programLimit = programmeIndex + 10;
  const latestTenProgrammes = allProgrammeSessions.length > programLimit
    ? allProgrammeSessions.slice(programmeIndex, programLimit)
    : allProgrammeSessions.slice(programmeIndex, allProgrammeSessions.length);

  const drillStatsProgrammes = await generateDrilllStatsProgrammes(playerId, latestTenProgrammes);
  return drillStatsProgrammes;
}

export const createDrillStatsProgrammes = async (playerId) =>
{
  if (!playerId)
  {
    return [
      {
        drillId: 'rondo-scan',
        stats: [],
      }, {
        drillId: 'colour-combo',
        stats: [],
      }, {
        drillId: 'wolfy-180',
        stats: [],
      }, {
        drillId: 'shoulder-sums',
        stats: [],
      }, {
        drillId: 'pressure-pass',
        stats: [],
      },
    ];
  };
  const allProgrammeStatsData = await getCachedAllProgrammeStats(playerId);
  if (!allProgrammeStatsData || !allProgrammeStatsData.success || allProgrammeStatsData.code !== 200)
    return { success: false };

  // Call deep programme stats API for 10 most recent programmes
  const { programmes } = allProgrammeStatsData.data;
  const allProgrammeSessions = getSortedProgrammes(programmes);
  if (allProgrammeSessions.length === 0)
  {
    return [
      {
        drillId: 'rondo-scan',
        stats: [],
      }, {
        drillId: 'colour-combo',
        stats: [],
      }, {
        drillId: 'wolfy-180',
        stats: [],
      }, {
        drillId: 'shoulder-sums',
        stats: [],
      }, {
        drillId: 'pressure-pass',
        stats: [],
      },
    ];
  }
  const latestTenProgrammes = allProgrammeSessions.length > 10
    ? allProgrammeSessions.slice(0, 10)
    : allProgrammeSessions;


  const drillStatsProgrammes = await generateDrilllStatsProgrammes(playerId, latestTenProgrammes);

  return { drillStats: drillStatsProgrammes, allProgrammeSessions };

}

export const createPlayerStatsObject = (profileData, drillData, clubLeaderboard, worldLeaderboard, latestPlayerStats) =>
{
  const clubLeaderboardData = clubLeaderboard.leaderboards;
  const worldLeaderboardData = worldLeaderboard.leaderboards;
  const latestDrillStats = latestPlayerStats.drillStats;
  const { rondo_scan, colour_combo, shoulder_sums, head_smart, pressure_pass, wolfy_180, finishing, headers, reaction_wall, volleys, board_test } = drillData;
  const drillDataObject = {
    id: profileData?.profile?.id,
    picture: profileData?.profile?.picture,
    firstname: profileData?.profile?.firstname,
    lastname: profileData?.profile?.lastname,
    clubName: profileData?.profile?.club_name,
    avgStats: [
      {
        drillId: 'rondo-scan',
        drillName: 'Rondo Scan',
        drillLogo: <RepeatOutlined />,
        avg_score: {
          player: rondo_scan?.profile?.avg_score,
          global: rondo_scan?.global?.avg_score,
        },
        avg_average_dwell: {
          player: rondo_scan?.profile?.avg_average_dwell !== null && rondo_scan?.profile?.avg_average_dwell !== undefined ? `${rondo_scan?.profile?.avg_average_dwell?.toFixed(2)}s` : `--`,
          global: rondo_scan?.global?.avg_average_dwell !== null && rondo_scan?.global?.avg_average_dwell !== undefined ? `${rondo_scan?.global?.avg_average_dwell?.toFixed(2)}s` : `--`,
        },
        avg_right_foot_shots: {
          player: rondo_scan?.profile?.avg_right_foot_shots,
          global: rondo_scan?.global?.avg_right_foot_shots,
        },
        avg_left_foot_shots: {
          player: rondo_scan?.profile?.avg_left_foot_shots,
          global: rondo_scan?.global?.avg_left_foot_shots,
        },
        avg_goals: {
          player: rondo_scan?.profile?.avg_goals,
          global: rondo_scan?.global?.avg_goals,
        },

        avg_accuracy: {
          player: rondo_scan?.profile?.avg_accuracy,
          global: rondo_scan?.global?.avg_accuracy,
        },
      },
      {
        drillId: 'colour-combo',
        drillName: 'Colour Combo',
        drillLogo: <HdrWeakOutlined />,
        avg_score: {
          player: colour_combo?.profile?.avg_score,
          global: colour_combo?.global?.avg_score,
        },
        avg_correct: {
          player: colour_combo?.profile?.avg_correct,
          global: colour_combo?.global?.avg_correct,
        },
        avg_incorrect: {
          player: colour_combo?.profile?.avg_incorrect,
          global: colour_combo?.global?.avg_incorrect,
        },
        avg_platinum: {
          player: colour_combo?.profile?.avg_platinum,
          global: colour_combo?.global?.avg_platinum,
        }, avg_average_dwell: {
          player: colour_combo?.profile?.avg_average_dwell,
          global: colour_combo?.global?.avg_average_dwell,
        },
      },
      {
        drillId: 'wolfy-180',
        drillName: 'Wolfy 180',
        drillLogo: <FilterTiltShiftOutlined />,
        avg_score: {
          player: wolfy_180?.profile?.avg_score,
          global: wolfy_180?.global?.avg_score,
        },
        avg_correct: {
          player: wolfy_180?.profile?.avg_correct,
          global: wolfy_180?.global?.avg_correct,
        },
        avg_incorrect: {
          player: wolfy_180?.profile?.avg_incorrect,
          global: wolfy_180?.global?.avg_incorrect,
        },
        avg_average_decision_time: {
          player: wolfy_180?.profile?.avg_average_decision_time !== null && wolfy_180?.profile?.avg_average_decision_time !== undefined ? `${wolfy_180?.profile?.avg_average_decision_time.toFixed(2)}s` : `--`,
          global: wolfy_180?.global?.avg_average_decision_time !== null && wolfy_180?.global?.avg_average_decision_time !== undefined ? `${wolfy_180?.global?.avg_average_decision_time.toFixed(2)}s` : `--`,
        },
        avg_accuracy: {
          player: wolfy_180?.profile?.avg_accuracy,
          global: wolfy_180?.global?.avg_accuracy,
        },
      },
      {
        drillId: 'shoulder-sums',
        drillName: 'Shoulder Sums',
        drillLogo: <RadarOutlined />,
        avg_score: {
          player: shoulder_sums?.profile?.avg_score,
          global: shoulder_sums?.global?.avg_score
        },
        correct: {
          player: shoulder_sums?.profile?.avg_goals,
          global: shoulder_sums?.global?.avg_goals,
        },
        avg_goals: {
          player: shoulder_sums?.profile?.avg_goals,
          global: shoulder_sums?.global?.avg_goals,
        },
        avg_right_foot_shots: {
          player: shoulder_sums?.profile?.avg_right_foot_shots,
          global: shoulder_sums?.global?.avg_right_foot_shots,
        },
        avg_left_foot_shots: {
          player: shoulder_sums?.profile?.avg_left_foot_shots,
          global: shoulder_sums?.global?.avg_left_foot_shots,
        },
        avg_accuracy: {
          player: shoulder_sums?.profile?.avg_accuracy,
          global: shoulder_sums?.global?.avg_accuracy,
        },
        avg_average_dwell: {
          player: shoulder_sums?.profile?.avg_average_dwell,
          global: shoulder_sums?.global?.avg_average_dwell,
        },
      }, {
        drillId: 'finishing',
        drillName: 'Finishing',
        drillLogo: <RadarOutlined />,
        avg_score: {
          player: finishing?.profile?.avg_score,
          global: finishing?.global?.avg_score
        },
        correct: {
          player: finishing?.profile?.avg_goals,
          global: finishing?.global?.avg_goals,
        },
        avg_goals: {
          player: finishing?.profile?.avg_goals,
          global: finishing?.global?.avg_goals,
        },
        avg_right_foot_shots: {
          player: finishing?.profile?.avg_right_foot_shots,
          global: finishing?.global?.avg_right_foot_shots,
        },
        avg_left_foot_shots: {
          player: finishing?.profile?.avg_left_foot_shots,
          global: finishing?.global?.avg_left_foot_shots,
        },
        avg_accuracy: {
          player: finishing?.profile?.avg_accuracy,
          global: finishing?.global?.avg_accuracy,
        },
        avg_average_dwell: {
          player: finishing?.profile?.avg_average_dwell,
          global: finishing?.global?.avg_average_dwell,
        },
      },
      /* {
        drillId: 'head-smart',
        drillName: 'Head Smart',
        drillLogo: <SportsSoccerOutlined />,
        avg_score: {
          player: head_smart?.profile?.avgScore,
          global: head_smart?.global?.avgScore,
        },
        correct: {
          player: head_smart?.profile?.avgSuccessful,
          global: head_smart?.global?.avgSuccessful,
        },
        incorrect: {
          player: head_smart?.profile?.avgWrong,
          global: head_smart?.global?.avgWrong,
        },
      }, */
      {
        drillId: 'pressure-pass',
        drillName: 'Pressure Pass',
        drillLogo: <SyncAltOutlined />,
        avg_score: {
          player: pressure_pass?.profile?.avg_score,
          global: pressure_pass?.global?.avg_score,
        },
        avg_average_dwell: {
          player: pressure_pass?.profile?.avg_average_dwell !== null && pressure_pass?.profile?.avg_average_dwell !== undefined ? `${pressure_pass?.profile?.avg_average_dwell.toFixed(2)}s` : `--`,
          global: pressure_pass?.global?.avg_average_dwell !== null && pressure_pass?.global?.avg_average_dwell !== undefined ? `${pressure_pass?.global?.avg_average_dwell.toFixed(2)}s` : `--`,
        },
        avg_correct: {
          player: pressure_pass?.profile?.avg_correct,
          global: pressure_pass?.global?.avg_correct,
        },
        avg_incorrect: {
          player: pressure_pass?.profile?.avg_incorrect,
          global: pressure_pass?.global?.avg_incorrect,
        },
        avg_right_foot_shots: {
          player: pressure_pass?.profile?.avg_right_foot_shots,
          global: pressure_pass?.global?.avg_right_foot_shots,
        },
        avg_left_foot_shots: {
          player: pressure_pass?.profile?.avg_left_foot_shots,
          global: pressure_pass?.global?.avg_left_foot_shots,

        },
        avg_accuracy: {
          player: pressure_pass?.profile?.avg_accuracy,
          global: pressure_pass?.global?.avg_accuracy,

        },
      },

    ],
    compareStats: [
      {
        drillId: 'rondo-scan',
        drillName: 'Rondo Scan',
        drillLogo: <RepeatOutlined />,
        bestScore: rondo_scan?.bestScore,
        avgScore: rondo_scan?.averageScore,
        lastScore: rondo_scan?.latestScore,
        clubRank: rondo_scan?.ranks.club, //getRank(profileData?.profile?.id, clubLeaderboardData?.pass_awareness_1_4?.scores),
        worldRank: rondo_scan?.ranks.world, //getRank(profileData?.profile?.id, worldLeaderboardData?.pass_awareness_1_4?.scores),
      },
      {
        drillId: 'colour-combo',
        drillName: 'Colour Combo',
        drillLogo: <HdrWeakOutlined />,
        bestScore: colour_combo?.bestScore,
        avgScore: colour_combo?.averageScore,
        lastScore: colour_combo?.latestScore,
        clubRank: colour_combo?.ranks.club,
        worldRank: colour_combo?.ranks.world,
        /* clubRank: getRank(profileData?.profile?.id, clubLeaderboardData?.colour_combo_warmup?.scores),
        worldRank: getRank(profileData?.profile?.id, worldLeaderboardData?.colour_combo_warmup?.scores), */
      },
      {
        drillId: 'shoulder-sums',
        drillName: 'Shoulder Sums',
        drillLogo: <RadarOutlined />,
        bestScore: shoulder_sums?.bestScore,
        avgScore: shoulder_sums?.averageScore,
        lastScore: shoulder_sums?.latestScore,
        clubRank: shoulder_sums?.ranks.club,
        worldRank: shoulder_sums?.ranks.world,
        /* clubRank: getRank(profileData?.profile?.id, clubLeaderboardData?.number_pass?.scores),
        worldRank: getRank(profileData?.profile?.id, worldLeaderboardData?.number_pass?.scores), */
      },
      {
        drillId: 'pressure-pass',
        drillName: 'Pressure Pass',
        drillLogo: <SyncAltOutlined />,
        bestScore: pressure_pass?.bestScore,
        avgScore: pressure_pass?.averageScore,
        lastScore: pressure_pass?.latestScore,
        clubRank: pressure_pass?.ranks.club,
        worldRank: pressure_pass?.ranks.world,
        /* clubRank: getRank(profileData?.profile?.id, clubLeaderboardData?.blocking?.scores),
        worldRank: getRank(profileData?.profile?.id, worldLeaderboardData?.blocking?.scores), */
      }, {
        drillId: 'finishing',
        drillName: 'Finishing',
        drillLogo: <SyncAltOutlined />,
        bestScore: finishing?.bestScore,
        avgScore: finishing?.averageScore,
        lastScore: finishing?.latestScore,
        clubRank: finishing?.ranks.club,
        worldRank: finishing?.ranks.world,
        /* clubRank: getRank(profileData?.profile?.id, clubLeaderboardData?.blocking?.scores),
        worldRank: getRank(profileData?.profile?.id, worldLeaderboardData?.blocking?.scores), */
      },
      {
        drillId: 'wolfy-180',
        drillName: 'Wolfy 180',
        drillLogo: <FilterTiltShiftOutlined />,
        // bestScore: wolfy_180?.profile?.max_score,
        // avgScore: wolfy_180?.profile?.avg_score,
        // lastScore: latestDrillStats?.wolfy_180?.latestStat?.score,
        bestScore: wolfy_180?.bestScore,
        avgScore: wolfy_180?.averageScore,
        lastScore: wolfy_180?.latestScore,
        clubRank: wolfy_180?.ranks.club,
        worldRank: wolfy_180?.ranks.world,
        /*         clubRank: getRank(profileData?.profile?.id, clubLeaderboardData?.wolfy_180?.scores),
                worldRank: getRank(profileData?.profile?.id, worldLeaderboardData?.wolfy_180?.scores), */
      },
    ],
    drillStats: [
      {
        drillId: 'rondo-scan',
        drillName: 'Rondo Scan',
        /* drillLogo: <RepeatOutlined />, */
        bestScore: rondo_scan?.bestScore,
        avgDwell: rondo_scan?.profile?.avg_average_dwell !== null ? `${rondo_scan?.profile?.avg_average_dwell.toFixed(2)}s` : `--`,
        rightFoot: rondo_scan?.profile.avg_right_foot_shots,
        leftFoot: rondo_scan?.profile.avg_right_foot_shots,
        goals: rondo_scan?.profile?.avg_goals,
        // level: rondo_scan?.profile.maxLevel,
        clubRank: rondo_scan?.ranks.club,
        worldRank: rondo_scan?.ranks.world,
      },
      {
        drillId: 'colour-combo',
        drillName: 'Colour Combo',
        /* drillLogo: <HdrWeakOutlined />, */
        bestScore: colour_combo?.bestScore,
        correct: colour_combo?.profile.avg_correct,
        incorrect: colour_combo?.profile.avg_incorrect,
        bonus: colour_combo?.profile.avg_platinum,
        clubRank: colour_combo?.ranks.club,
        worldRank: colour_combo?.ranks.world,
      },
      {
        drillId: 'shoulder-sums',
        drillName: 'Shoulder Sums',
        /* drillLogo: <RadarOutlined />, */
        bestScore: shoulder_sums?.bestScore,
        correct: shoulder_sums?.profile.avg_goals,
        rightFoot: shoulder_sums?.profile.avg_right_foot_shots,
        leftFoot: shoulder_sums?.profile.avg_left_foot_shots,
        clubRank: shoulder_sums?.ranks.club,
        worldRank: shoulder_sums?.ranks.world,
      }, {
        drillId: 'finishing',
        drillName: 'Finishing',
        /* drillLogo: <RadarOutlined />, */
        bestScore: finishing?.bestScore,
        correct: finishing?.profile.avg_goals,
        rightFoot: finishing?.profile.avg_right_foot_shots,
        leftFoot: finishing?.profile.avg_left_foot_shots,
        clubRank: finishing?.ranks.club,
        worldRank: finishing?.ranks.world,
      }, {
        drillId: 'headers',
        drillName: 'Headers',
        /* drillLogo: <RadarOutlined />, */
        bestScore: headers?.bestScore,
        correct: headers?.profile.avg_goals,
        rightFoot: headers?.profile.avg_right_foot_shots,
        leftFoot: headers?.profile.avg_left_foot_shots,
        clubRank: headers?.ranks.club,
        worldRank: headers?.ranks.world,
      }, {
        drillId: 'reation-wall',
        drillName: 'Reaction Wall',
        /* drillLogo: <RadarOutlined />, */
        bestScore: reaction_wall?.bestScore,
        correct: reaction_wall?.profile.avg_goals,
        rightFoot: reaction_wall?.profile.avg_right_foot_shots,
        leftFoot: reaction_wall?.profile.avg_left_foot_shots,
        clubRank: reaction_wall?.ranks.club,
        worldRank: reaction_wall?.ranks.world,
      },
      {
        drillId: 'volleys',
        drillName: 'Volleys',
        /* drillLogo: <RadarOutlined />, */
        bestScore: volleys?.bestScore,
        correct: volleys?.profile.avg_goals,
        rightFoot: volleys?.profile.avg_right_foot_shots,
        leftFoot: volleys?.profile.avg_left_foot_shots,
        clubRank: volleys?.ranks.club,
        worldRank: volleys?.ranks.world,
      }, {
        drillId: 'board-test',
        drillName: 'Board Test',
        /* drillLogo: <RadarOutlined />, */
        bestScore: board_test?.bestScore,
        correct: board_test?.profile.avg_goals,
        rightFoot: board_test?.profile.avg_right_foot_shots,
        leftFoot: board_test?.profile.avg_left_foot_shots,
        clubRank: board_test?.ranks.club,
        worldRank: board_test?.ranks.world,
      },
      {
        drillId: 'pressure-pass',
        drillName: 'Pressure Pass',
        /* drillLogo: <SyncAltOutlined />, */
        bestScore: pressure_pass?.bestScore,
        avgDwell: pressure_pass?.profile?.avg_average_dwell !== null ? `${pressure_pass?.profile?.avg_average_dwell.toFixed(2)}s` : `--`,
        correct: pressure_pass?.profile.avg_correct,
        incorrect: pressure_pass?.profile.avg_incorrect,
        rightFoot: pressure_pass?.profile.avg_right_foot_shots,
        leftFoot: pressure_pass?.profile.avg_left_foot_shots,
        clubRank: pressure_pass?.ranks.club,
        worldRank: pressure_pass?.ranks.world,
      },
      {
        drillId: 'wolfy-180',
        drillName: 'Wolfy 180',
        /* drillLogo: <FilterTiltShiftOutlined />, */
        bestScore: wolfy_180?.bestScore,
        correct: wolfy_180?.profile.avg_correct,
        incorrect: wolfy_180?.profile.avg_incorrect,
        avgDecision: wolfy_180?.profile?.avg_average_decision_time !== null ? `${wolfy_180?.profile?.avg_average_decision_time.toFixed(2)}s` : `--`,
        clubRank: wolfy_180?.ranks.club,
        worldRank: wolfy_180?.ranks.world,
      },
      /* {
        drillId: 'head-smart',
        drillName: 'Head Smart',
        drillLogo: <SportsSoccerOutlined />,
        bestScore: head_smart?.bestScore,
        correct: head_smart?.profile.avg_correct,
        incorrect: head_smart?.profile.avg_incorrect,
        avgDecision: head_smart?.profile?.avg_average_decision_time !== null ? `${head_smart?.profile?.avg_average_decision_time.toFixed(2)}s` : `--`,
        clubRank: head_smart?.ranks.club,
        worldRank: head_smart?.ranks.world,
      }, */
      // {
      //   drillId: 'additional-drill',
      //   drillName: 'Additional Drill',
      //   drillLogo: <RepeatOutlined />,
      //   score: '625',
      //   bestScore: '126,000',
      //   topScore: '8.06',
      //   totalBalls: '11,000',
      //   correct: '11,000',
      //   incorrect: '10,080',
      //   avgDwell: '2.64',
      //   rightFoot: '2,200',
      //   leftFoot: '2,100',
      //   level: '11',
      //   clubRank: '1',
      //   worldRank: '1',
      // },
      // {
      //   drillId: 'additional-drill-2',
      //   drillName: 'Additional Drill 2',
      //   drillLogo: <HdrWeakOutlined />,
      //   score: '625',
      //   bestScore: '125,000',
      //   topScore: '8.06',
      //   totalBalls: '12,000',
      //   correct: '12,000',
      //   incorrect: '9,080',
      //   avgDwell: '1.64',
      //   rightFoot: '1,200',
      //   leftFoot: '1,100',
      //   level: '12',
      //   clubRank: '5',
      //   worldRank: '35',
      // },
    ],
    levels: [
      {
        drillId: 'rondo-scan',
        drillName: 'Rondo Scan',
        levels: rondo_scan?.levels,
      },
      {
        drillId: 'colour-combo',
        drillName: 'Colour Combo',
        levels: colour_combo?.levels,
      },
      {
        drillId: 'shoulder-sums',
        drillName: 'Shoulder Sums',
        levels: shoulder_sums?.levels,
      },
      {
        drillId: 'pressure-pass',
        drillName: 'Pressure Pass',
        levels: pressure_pass?.levels,
      },
      {
        drillId: 'wolfy-180',
        drillName: 'Wolfy 180',
        levels: wolfy_180?.levels,

      },
    ],
  };
  return drillDataObject;
};

export const squadStatsHelper = (avgStats, sessionStats) =>
{
  return {
    sessionStats: {
      headers: {
        control: {
          drillId: 'control',
          drillName: 'Control',
          scores: sessionStats.headers_control.player,
        },
        shooting: {
          drillId: 'shooting',
          drillName: 'Shooting',
          scores: sessionStats.headers_shooting.player,
        },
        clearing: {
          drillId: 'clearing',
          drillName: 'Clearing',
          scores: sessionStats.headers_clearing.player,
        },
        passing: {
          drillId: 'passing',
          drillName: 'Passing',
          scores: sessionStats.headers_passing.player,
        }
      },
      fieldGeneral: {
        singleDrillLevel: true,
        drillId: 'fieldGeneral',
        drillName: 'Field General',
        scores: sessionStats.field_general.player,
      },
      reactionWall: {
        micro: {
          drillId: 'micro',
          drillName: 'Micro',
          scores: sessionStats.reaction_wall_micro.player,
        },
        60: {
          drillId: '60',
          drillName: '60',
          scores: sessionStats.reaction_wall_60.player,
        },
        180: {
          drillId: '180',
          drillName: '180',
          scores: sessionStats.reaction_wall_180.player,
        },
        360: {
          drillId: '360',
          drillName: '360',
          scores: sessionStats.reaction_wall_360.player,
        }
      },
      hoops: {
        omw: {
          drillId: 'omw',
          drillName: 'OMW',
          scores: sessionStats.hoops_omw.player,
        },
        2020: {
          drillId: '2020',
          drillName: '2020',
          scores: sessionStats.hoops_2020.player,
        },
        gotw: {
          drillId: 'gotw',
          drillName: 'GOTW',
          scores: sessionStats.hoops_gotw.player,
        },
        caution: {
          drillId: 'caution',
          drillName: 'Caution',
          scores: sessionStats.hoops_caution.player,
        },
        partyUp: {
          drillId: 'partyUp',
          drillName: 'Party Up',
          scores: sessionStats.hoops_party_up.player,
        },
      }
    },
    drillStats: {
      headers: {
        control: {
          drillId: 'control',
          drillName: 'Control',
          totalScore: avgStats.headers_control.player.totalScore,
          timePlayed: avgStats.headers_control.player.timePlayed,
          totalBallsLaunched: avgStats.headers_control.player.totalBallsLaunched,
          totalBallsHit: avgStats.headers_control.player.totalBallsHit,
          totalMissed: avgStats.headers_control.player.totalMissed,
          bestStreak: avgStats.headers_control.player.bestStreak,
          avgHeadSpeed: avgStats.headers_control.player.avgHeadSpeed,
          avgAccuracy: avgStats.headers_control.player.avgAccuracy,
          avgStrikePoint: avgStats.headers_control.player.avgStrikePoint,
        },
        shooting: {
          drillId: 'shooting',
          drillName: 'Shooting',
          totalScore: avgStats.headers_shooting.player.totalScore,
          timePlayed: avgStats.headers_shooting.player.timePlayed,
          totalBallsLaunched: avgStats.headers_shooting.player.totalBallsLaunched,
          totalGoalsScored: avgStats.headers_shooting.player.totalGoalsScored,
          totalGoalsSaved: avgStats.headers_shooting.player.totalGoalsSaved,
          totalMissed: avgStats.headers_shooting.player.totalMissed,
          bestStreak: avgStats.headers_shooting.player.bestStreak,
          avgAccuracy: avgStats.headers_shooting.player.avgAccuracy,
          avgStrikePoint: avgStats.headers_shooting.player.avgStrikePoint,
        },
        clearing: {
          drillId: 'clearing',
          drillName: 'Clearing',
          totalScore: avgStats.headers_clearing.player.totalScore,
          timePlayed: avgStats.headers_clearing.player.timePlayed,
          totalBallsLaunched: avgStats.headers_clearing.player.totalBallsLaunched,
          totalBallsCleared: avgStats.headers_clearing.player.totalBallsCleared,
          totalMissed: avgStats.headers_clearing.player.totalMissed,
          bestStreak: avgStats.headers_clearing.player.bestStreak,
          avgHeadSpeed: avgStats.headers_clearing.player.avgHeadSpeed,
          avgAccuracy: avgStats.headers_clearing.player.avgAccuracy,
          avgStrikePoint: avgStats.headers_clearing.player.avgStrikePoint,
        },
        passing: {
          drillId: 'passing',
          drillName: 'Passing',
          totalScore: avgStats.headers_passing.player.totalScore,
          timePlayed: avgStats.headers_passing.player.timePlayed,
          totalBallsLaunched: avgStats.headers_passing.player.totalBallsLaunched,
          totalCorrectPasses: avgStats.headers_passing.player.totalCorrectPasses,
          totalWrongPasses: avgStats.headers_passing.player.totalWrongPasses,
          bestStreak: avgStats.headers_passing.player.bestStreak,
          avgHeadSpeed: avgStats.headers_passing.player.avgHeadSpeed,
          avgAccuracy: avgStats.headers_passing.player.avgAccuracy,
          avgStrikePoint: avgStats.headers_passing.player.avgStrikePoint,
        }
      },
      fieldGeneral: {
        singleDrillLevel: true,
        drillId: 'fieldGeneral',
        drillName: 'Field General',
        totalScore: avgStats.field_general.player.totalScore,
        timePlayed: avgStats.field_general.player.timePlayed,
        totalSnaps: avgStats.field_general.player.totalSnaps,
        totalCaught: avgStats.field_general.player.totalCaught,
        totalPassesComplete: avgStats.field_general.player.totalPassesComplete,
        totalMissed: avgStats.field_general.player.totalMissed,
        bestStreakEver: avgStats.field_general.player.bestStreakEver,
        averageReleaseTime: avgStats.field_general.player.averageReleaseTime,
        overallAverageAccuracy: avgStats.field_general.player.overallAverageAccuracy
      },
      reactionWall: {
        micro: {
          drillId: 'micro',
          drillName: 'Micro',
          bestScore: avgStats.reaction_wall_micro.player.bestScore,
          bestScoreChase: avgStats.reaction_wall_micro.player.bestScoreChase,
          timePlayed: avgStats.reaction_wall_micro.player.timePlayed,
          totalHits: avgStats.reaction_wall_micro.player.totalHits,
          fastestReaction: avgStats.reaction_wall_micro.player.fastestReaction,
          slowestReaction: avgStats.reaction_wall_micro.player.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_micro.player.handBias,
        },
        60: {
          drillId: '60',
          drillName: '60',
          bestScore: avgStats.reaction_wall_60.player.bestScore,
          bestScoreChase: avgStats.reaction_wall_60.player.bestScoreChase,
          timePlayed: avgStats.reaction_wall_60.player.timePlayed,
          totalHits: avgStats.reaction_wall_60.player.totalHits,
          fastestReaction: avgStats.reaction_wall_60.player.fastestReaction,
          slowestReaction: avgStats.reaction_wall_60.player.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_60.player.handBias,
        },
        180: {
          drillId: '180',
          drillName: '180',
          bestScore: avgStats.reaction_wall_180.player.bestScore,
          bestScoreChase: avgStats.reaction_wall_180.player.bestScoreChase,
          timePlayed: avgStats.reaction_wall_180.player.timePlayed,
          totalHits: avgStats.reaction_wall_180.player.totalHits,
          fastestReaction: avgStats.reaction_wall_180.player.fastestReaction,
          slowestReaction: avgStats.reaction_wall_180.player.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_180.player.handBias,
        },
        360: {
          drillId: '360',
          drillName: '360',
          bestScore: avgStats.reaction_wall_360.player.bestScore,
          bestScoreChase: avgStats.reaction_wall_360.player.bestScoreChase,
          timePlayed: avgStats.reaction_wall_360.player.timePlayed,
          totalHits: avgStats.reaction_wall_360.player.totalHits,
          fastestReaction: avgStats.reaction_wall_360.player.fastestReaction,
          slowestReaction: avgStats.reaction_wall_360.player.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_360.player.handBias,
        }
      },
      hoops: {
        omw: {
          drillId: 'omw',
          drillName: 'OMW',
          bestScore: avgStats.hoops_omw.player.bestScore,
          timePlayed: avgStats.hoops_omw.player.timePlayed,
          totalHit: avgStats.hoops_omw.player.totalHit,
          totalMissed: avgStats.hoops_omw.player.totalMissed,
          totalBonusHits: avgStats.hoops_omw.player.totalBonusHits,
          bestStreak: avgStats.hoops_omw.player.bestStreak,
          avgMoveSpeed: avgStats.hoops_omw.player.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_omw.player.avgAccuracy,
        },
        2020: {
          drillId: '2020',
          drillName: '2020',
          timePlayed: avgStats.hoops_2020.player.timePlayed,
          totalHit: avgStats.hoops_2020.player.totalHit,
          totalMissed: avgStats.hoops_2020.player.totalMissed,
          totalBonusHits: avgStats.hoops_2020.player.totalBonusHits,
          bestStreak: avgStats.hoops_2020.player.bestStreak,
          avgMoveSpeed: avgStats.hoops_2020.player.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_2020.player.avgAccuracy,
        },
        gotw: {
          drillId: 'gotw',
          drillName: 'GOTW',
          timePlayed: avgStats.hoops_gotw.player.timePlayed,
          totalHit: avgStats.hoops_gotw.player.totalHit,
          totalMissed: avgStats.hoops_gotw.player.totalMissed,
          totalBonusHits: avgStats.hoops_gotw.player.totalBonusHits,
          bestStreak: avgStats.hoops_gotw.player.bestStreak,
          avgMoveSpeed: avgStats.hoops_gotw.player.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_gotw.player.avgAccuracy,
        },
        caution: {
          drillId: 'caution',
          drillName: 'Caution',
          timePlayed: avgStats.hoops_caution.player.timePlayed,
          totalHit: avgStats.hoops_caution.player.totalHit,
          totalMissed: avgStats.hoops_caution.player.totalMissed,
          totalBonusHits: avgStats.hoops_caution.player.totalBonusHits,
          bestStreak: avgStats.hoops_caution.player.bestStreak,
          avgMoveSpeed: avgStats.hoops_caution.player.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_caution.player.avgAccuracy,
        },
        partyUp: {
          drillId: 'partyUp',
          drillName: 'Party Up',
          timePlayed: avgStats.hoops_party_up.player.timePlayed,
          totalHit: avgStats.hoops_party_up.player.totalHit,
          totalMissed: avgStats.hoops_party_up.player.totalMissed,
          totalBonusHits: avgStats.hoops_party_up.player.totalBonusHits,
          bestStreak: avgStats.hoops_party_up.player.bestStreak,
          avgMoveSpeed: avgStats.hoops_party_up.player.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_party_up.player.avgAccuracy,
        },
      }
    },
    worldDrillStats: {
      headers: {
        control: {
          drillId: 'control',
          drillName: 'Control',
          totalScore: avgStats.headers_control.global.totalScore,
          timePlayed: avgStats.headers_control.global.timePlayed,
          totalBallsLaunched: avgStats.headers_control.global.totalBallsLaunched,
          totalBallsHit: avgStats.headers_control.global.totalBallsHit,
          totalMissed: avgStats.headers_control.global.totalMissed,
          bestStreak: avgStats.headers_control.global.bestStreak,
          avgHeadSpeed: avgStats.headers_control.global.avgHeadSpeed,
          avgAccuracy: avgStats.headers_control.global.avgAccuracy,
          avgStrikePoint: avgStats.headers_control.global.avgStrikePoint,
        },
        shooting: {
          drillId: 'shooting',
          drillName: 'Shooting',
          totalScore: avgStats.headers_shooting.global.totalScore,
          timePlayed: avgStats.headers_shooting.global.timePlayed,
          totalBallsLaunched: avgStats.headers_shooting.global.totalBallsLaunched,
          totalGoalsScored: avgStats.headers_shooting.global.totalGoalsScored,
          totalGoalsSaved: avgStats.headers_shooting.global.totalGoalsSaved,
          totalMissed: avgStats.headers_shooting.global.totalMissed,
          bestStreak: avgStats.headers_shooting.global.bestStreak,
          avgAccuracy: avgStats.headers_shooting.global.avgAccuracy,
          avgStrikePoint: avgStats.headers_shooting.global.avgStrikePoint,
        },
        clearing: {
          drillId: 'clearing',
          drillName: 'Clearing',
          totalScore: avgStats.headers_clearing.global.totalScore,
          timePlayed: avgStats.headers_clearing.global.timePlayed,
          totalBallsLaunched: avgStats.headers_clearing.global.totalBallsLaunched,
          totalBallsCleared: avgStats.headers_clearing.global.totalBallsCleared,
          totalMissed: avgStats.headers_clearing.global.totalMissed,
          bestStreak: avgStats.headers_clearing.global.bestStreak,
          avgHeadSpeed: avgStats.headers_clearing.global.avgHeadSpeed,
          avgAccuracy: avgStats.headers_clearing.global.avgAccuracy,
          avgStrikePoint: avgStats.headers_clearing.global.avgStrikePoint,
        },
        passing: {
          drillId: 'passing',
          drillName: 'Passing',
          totalScore: avgStats.headers_passing.global.totalScore,
          timePlayed: avgStats.headers_passing.global.timePlayed,
          totalBallsLaunched: avgStats.headers_passing.player.totalBallsLaunched,
          totalCorrectPasses: avgStats.headers_passing.global.totalCorrectPasses,
          totalWrongPasses: avgStats.headers_passing.global.totalWrongPasses,
          bestStreak: avgStats.headers_passing.global.bestStreak,
          avgHeadSpeed: avgStats.headers_passing.global.avgHeadSpeed,
          avgAccuracy: avgStats.headers_passing.global.avgAccuracy,
          avgStrikePoint: avgStats.headers_passing.global.avgStrikePoint,
        }
      },
      fieldGeneral: {
        singleDrillLevel: true,
        drillId: 'fieldGeneral',
        drillName: 'Field General',
        totalScore: avgStats.field_general.global.totalScore,
        timePlayed: avgStats.field_general.global.timePlayed,
        totalSnaps: avgStats.field_general.global.totalSnaps,
        totalCaught: avgStats.field_general.global.totalCaught,
        totalPassesComplete: avgStats.field_general.global.totalPassesComplete,
        totalMissed: avgStats.field_general.global.totalMissed,
        bestStreakEver: avgStats.field_general.global.bestStreakEver,
        averageReleaseTime: avgStats.field_general.global.averageReleaseTime,
        overallAverageAccuracy: avgStats.field_general.global.overallAverageAccuracy
      },
      reactionWall: {
        micro: {
          drillId: 'micro',
          drillName: 'Micro',
          bestScore: avgStats.reaction_wall_micro.global.bestScore,
          bestScoreChase: avgStats.reaction_wall_micro.global.bestScoreChase,
          timePlayed: avgStats.reaction_wall_micro.global.timePlayed,
          totalHits: avgStats.reaction_wall_micro.global.totalHits,
          fastestReaction: avgStats.reaction_wall_micro.global.fastestReaction,
          slowestReaction: avgStats.reaction_wall_micro.global.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_micro.global.handBias,
        },
        60: {
          drillId: '60',
          drillName: '60',
          bestScore: avgStats.reaction_wall_60.global.bestScore,
          bestScoreChase: avgStats.reaction_wall_60.global.bestScoreChase,
          timePlayed: avgStats.reaction_wall_60.global.timePlayed,
          totalHits: avgStats.reaction_wall_60.global.totalHits,
          fastestReaction: avgStats.reaction_wall_60.global.fastestReaction,
          slowestReaction: avgStats.reaction_wall_60.player.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_60.global.handBias,
        },
        180: {
          drillId: '180',
          drillName: '180',
          bestScore: avgStats.reaction_wall_180.global.bestScore,
          bestScoreChase: avgStats.reaction_wall_180.global.bestScoreChase,
          timePlayed: avgStats.reaction_wall_180.global.timePlayed,
          totalHits: avgStats.reaction_wall_180.global.totalHits,
          fastestReaction: avgStats.reaction_wall_180.global.fastestReaction,
          slowestReaction: avgStats.reaction_wall_180.global.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_180.global.handBias,
        },
        360: {
          drillId: '360',
          drillName: '360',
          bestScore: avgStats.reaction_wall_360.global.bestScore,
          bestScoreChase: avgStats.reaction_wall_360.global.bestScoreChase,
          timePlayed: avgStats.reaction_wall_360.global.timePlayed,
          totalHits: avgStats.reaction_wall_360.global.totalHits,
          fastestReaction: avgStats.reaction_wall_360.global.fastestReaction,
          slowestReaction: avgStats.reaction_wall_360.global.slowestReaction,
          avgReactionTime: avgStats.reaction_wall_360.global.handBias,
        }
      },
      hoops: {
        omw: {
          drillId: 'omw',
          drillName: 'OMW',
          bestScore: avgStats.hoops_omw.global.bestScore,
          timePlayed: avgStats.hoops_omw.global.timePlayed,
          totalHit: avgStats.hoops_omw.global.totalHit,
          totalMissed: avgStats.hoops_omw.global.totalMissed,
          totalBonusHits: avgStats.hoops_omw.global.totalBonusHits,
          bestStreak: avgStats.hoops_omw.global.bestStreak,
          avgMoveSpeed: avgStats.hoops_omw.global.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_omw.global.avgAccuracy,
        },
        2020: {
          drillId: '2020',
          drillName: '2020',
          timePlayed: avgStats.hoops_2020.global.timePlayed,
          totalHit: avgStats.hoops_2020.global.totalHit,
          totalMissed: avgStats.hoops_2020.global.totalMissed,
          totalBonusHits: avgStats.hoops_2020.global.totalBonusHits,
          bestStreak: avgStats.hoops_2020.global.bestStreak,
          avgMoveSpeed: avgStats.hoops_2020.global.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_2020.global.avgAccuracy,
        },
        gotw: {
          drillId: 'gotw',
          drillName: 'GOTW',
          timePlayed: avgStats.hoops_gotw.global.timePlayed,
          totalHit: avgStats.hoops_gotw.global.totalHit,
          totalMissed: avgStats.hoops_gotw.global.totalMissed,
          totalBonusHits: avgStats.hoops_gotw.global.totalBonusHits,
          bestStreak: avgStats.hoops_gotw.global.bestStreak,
          avgMoveSpeed: avgStats.hoops_gotw.global.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_gotw.global.avgAccuracy,
        },
        caution: {
          drillId: 'caution',
          drillName: 'Caution',
          timePlayed: avgStats.hoops_caution.global.timePlayed,
          totalHit: avgStats.hoops_caution.global.totalHit,
          totalMissed: avgStats.hoops_caution.global.totalMissed,
          totalBonusHits: avgStats.hoops_caution.global.totalBonusHits,
          bestStreak: avgStats.hoops_caution.global.bestStreak,
          avgMoveSpeed: avgStats.hoops_caution.global.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_caution.global.avgAccuracy,
        },
        partyUp: {
          drillId: 'partyUp',
          drillName: 'Party Up',
          timePlayed: avgStats.hoops_party_up.global.timePlayed,
          totalHit: avgStats.hoops_party_up.global.totalHit,
          totalMissed: avgStats.hoops_party_up.global.totalMissed,
          totalBonusHits: avgStats.hoops_party_up.global.totalBonusHits,
          bestStreak: avgStats.hoops_party_up.global.bestStreak,
          avgMoveSpeed: avgStats.hoops_party_up.global.avgMoveSpeed,
          avgAccuracy: avgStats.hoops_party_up.global.avgAccuracy,
        },
      }
    }
  }
};
